import { format } from 'date-fns'
import { useRef } from 'react'
import { Button } from 'reactstrap'
import { notEmpty } from 'src/helpers/utils'
import { usePositionDetailsById } from 'src/queries'
import { usePositionSummaryReport } from 'src/queries/cat/reporting/usePositionSummaryReport'

interface BodyProps {
  id: number
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const report = usePositionSummaryReport(id)
  const details = usePositionDetailsById(id)
  const linkRef = useRef()
  const mineType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  const formatedDate = format(new Date(), 'MM.dd.yyyy')
  const fileName = [
    details?._contract?.abbreviation,
    details?.id,
    formatedDate
  ].filter(notEmpty).join('_').trim().replace(/[^a-zA-Z0-9.]+/g, '_')

  if (typeof report === 'string') {
    return (
      <Button
        tag='a'
        color='primary'
        block
        href={`data:${mineType};base64,${report}`}
        ref={linkRef.current} download={`${fileName}.docx`}
      >
        Download
      </Button>
    )
  }

  return (
    <b>There was an issue getting the report. Please try again later.</b>
  )
}

export default Body
